import { Component, Input, OnInit } from '@angular/core';
import { VoucherType } from '~shared/models';
import { NEWSLETTER_SUBSCRIPTION_PERCENTAGE } from '../../newsletter-subscription.constant';

@Component({
  selector: 'app-newsletter-bubble',
  templateUrl: './newsletterBubble.component.html',
  styleUrls: ['./newsletterBubble.component.scss'],
})
export class NewsletterBubbleComponent implements OnInit {
  @Input() voucherType?: VoucherType;
  @Input() amount: string;
  @Input() market: string;
  @Input() NLDiscount: string;
  readonly PERCENTAGE = NEWSLETTER_SUBSCRIPTION_PERCENTAGE;

  ngOnInit(): void {
    this.voucherType = this.voucherType || NEWSLETTER_SUBSCRIPTION_PERCENTAGE;
  }
}
